import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import useFirebaseStore from '@di-shared/features/environment/firebaseStore';

const BADGE_STYLE = {padding: '0 4px', minHeight: '16px', fontSize: '1rem'};

function WhitelistAccountBadge() {
  const {vin} = useEnvironmentStore(({vin}) => ({vin}));
  const {checkGlobalVinWhitelist, checkCapitalVinWhitelist, checkNaVinWhitelist} = useFirebaseStore(
    ({checkGlobalVinWhitelist, checkCapitalVinWhitelist, checkNaVinWhitelist}) => ({
      checkGlobalVinWhitelist,
      checkCapitalVinWhitelist,
      checkNaVinWhitelist,
    })
  );

  if (!vin) {
    return null;
  }

  const isGlobalWhitelisted = checkGlobalVinWhitelist(vin);
  const isCapitalWhitelisted = checkCapitalVinWhitelist(vin);
  const isNaWhitelisted = checkNaVinWhitelist(vin);

  if (!isGlobalWhitelisted && !isCapitalWhitelisted && !isNaWhitelisted) {
    return null;
  }

  return (
    <div
      className="badge_box"
      style={{
        position: 'fixed',
        top: 'env(safe-area-inset-top)',
        left: 0,
        margin: '4px 0 0 4px',
        opacity: 0.6,
        pointerEvents: 'none',
        zIndex: 1000,
      }}
    >
      {isGlobalWhitelisted && (
        <span
          className="badge badge_container_blue badge_20px"
          style={BADGE_STYLE}
        >
          글로벌 화이트리스트
        </span>
      )}
      {isCapitalWhitelisted && (
        <span
          className="badge badge_container_ultimate badge_20px"
          style={BADGE_STYLE}
        >
          캐피탈 화이트리스트
        </span>
      )}
      {isNaWhitelisted && (
        <span
          className="badge badge_container_yellow badge_20px"
          style={BADGE_STYLE}
        >
          NA 화이트리스트
        </span>
      )}
    </div>
  );
}

export default WhitelistAccountBadge;
